import React from "react";

import st from './messages.module.css'

const Messages = () => {
  return <div className={st.messages_container} >Messages</div>;
};

export default Messages;
